import { getExperienceInitCookie } from './experienceInitCookie';

export const getToPost = (url: string): void => {
  const questionIndex = url.indexOf('?');
  const formUrl = questionIndex > 0 ? url.substring(0, questionIndex) : url;
  const params = questionIndex > 0 ? url.substring(questionIndex + 1) : '';
  const paramArray = params.split('&');
  const paramsCount = paramArray.length;
  const formElem = document.createElement('form');

  const bodyElem = document.getElementsByTagName('body')[0];
  bodyElem.appendChild(formElem);

  formElem.setAttribute('method', 'POST');
  formElem.setAttribute('action', formUrl);

  for (let i = 0; i < paramsCount; i += 1) {
    const param = paramArray[i];
    const inputAttr = document.createElement('input');
    const tokens = param.split('=');
    inputAttr.setAttribute('type', 'hidden');
    inputAttr.setAttribute('name', tokens[0]);
    inputAttr.setAttribute('value', tokens.length > 1 ? tokens[1] : '');
    formElem.appendChild(inputAttr);
  }

  const token = getExperienceInitCookie()?.csrfToken;

  if (token) {
    const inputAttr = document.createElement('input');
    inputAttr.setAttribute('type', 'hidden');
    inputAttr.setAttribute('name', '_csrf');
    inputAttr.setAttribute('value', token);
    formElem.appendChild(inputAttr);
  }

  formElem.submit();
};
